<script>
  import { resolveStatusClass } from '@utils/status'

  export default {
    props: {
      status: {
        type: String,
        default: 'active'
      },
      value: {
        type: String,
        default: undefined
      },
      enableBorder: {
        type: Boolean,
        default: false
      },
      isStriped: {
        type: Boolean,
        default: false
      },
      isStripedAlternate: {
        type: Boolean,
        default: false
      },
      isSmallMode: {
        type: Boolean,
        default: false
      },
      extraClasses: {
        type: String,
        default: ''
      },
      textClasses: {
        type: [String, Function],
        default: ''
      },
    },
    data() {
      return {
        finishedLoading: false,
      }
    },
    computed:{
      resolvedTextClasses(){
        if (typeof(this.textClasses) === 'string'){
          return this.textClasses
        }else if(typeof(this.textClasses) === 'function'){
          return this.textClasses()
        }
        return ''
      }
    },
    async created() {
      this.finishedLoading = true
    },
    methods: {
      resolveStatusClass,
    },
  }
</script>

<template>
  <span
    v-if="finishedLoading"
    class="block-status tw-flex align-items-center rounded-pill pl-1"
    :class="[extraClasses, { border: enableBorder, 'tw-pr-4': !isSmallMode, 'pr-1': isSmallMode, 'stripe-a': (isStriped && isStripedAlternate), 'stripe-b': (isStriped && !isStripedAlternate) }]">
    <span
      class='status-icon'
      :class="[
        { 'mg-r-u': isSmallMode },
        resolveStatusClass(status ? status.toLowerCase() : ''),
      ]"
    >
    </span>
    <span v-if="!!!value && !isSmallMode" class="status-text text-capitalize" :class="resolvedTextClasses">{{ status }}</span>
    <span v-if="!!value && !isSmallMode" class="status-text text-capitalize" :class="resolvedTextClasses">{{ value }}</span>
  </span>
</template>
